import imagetransferHome from "./imagetransfer.vue";
// import BuildDetails from "@/components/tiny/builddetail.vue";
import lightSwiper from "@/jsUtils/plugins/swiper5.4.5/swiper.min.5.4.5.js";
import "@/jsUtils/plugins/swiper5.4.5/swiper.min.5.4.5.css";
import { isIos_wecha } from "@/jsUtils/mobileUtils.js";
// import $ from "@/jsUtils/plugins/jquery2.2.5.js";
import CrooperImg from "@/components/tools/cropperImg.vue";
import Homehead from "@/Painting/home/home_head.vue";
import appWidget from "@/components/widget/index.vue";
import { getLocalImagePath } from "@/lang/getLocalImg.js";
export default {
  components: {
    imagetransferHome,
    // 上传图片，进行变换的首页
    // BuildDetails,                // 进行拼装的第二页面
    CrooperImg,
    // 图片裁剪组件
    Homehead,
    // 首页头部
    appWidget // 应用组件
  },

  data() {
    return {
      buildcontrol: null,
      //拼装控制器
      swiper: null,
      //轮播控制器

      // whitePart : require('@/assets/public/white.png'),         //白色颗粒图
      // blackPart : require('@/assets/public/black.png'),         //黑色颗粒图

      historyState: null,
      //记录当前的翻页状态
      // showpage1 : true,										//是否显示第一页
      // showpage2 : false,										//是否显示第二页

      crop_showShape: false //是否显示裁剪框的可选择形状
    };
  },

  // 传递参数
  props: {
    headImgUrl: {
      type: String
      // required: true,
    },

    carousel_01: {
      type: String,
      required: true
    },
    carousel_02: {
      type: String,
      required: true
    },
    carousel_03: {
      type: String,
      required: true
    },
    carousel_04: {
      type: String,
      required: true
    },
    carousel_05: {
      type: String,
      required: true
    },
    carousel_06: {
      type: String,
      required: true
    },
    ex_original: {
      type: String,
      required: true
    },
    ex_target: {
      type: String,
      required: true
    },
    shopUrl: {
      type: String,
      required: true,
      default: "https://www.amazon.com/dp/B08TWGWRCQ?th=1"
    },
    productName: {
      type: String,
      required: true,
      default: "Original"
    },
    // 宽高比
    widthheight_ratio: {
      type: Number,
      required: true,
      default: 1
    },
    // 裁剪框的正方形指示框
    crop_shape_square_image: {
      type: Object,
      required: false,
      default: null
    },
    // 裁剪框的纵向指示框
    crop_shape_horizontal_image: {
      type: Object,
      required: false,
      default: null
    },
    // 裁剪框的横向指示框
    crop_shape_vertical_image: {
      type: Object,
      required: false,
      default: null
    },
    product_introduce: {
      type: String,
      required: false
    }
  },
  // props: ['headImgUrl'],

  created() {},
  // 加载拼装控制件
  mounted() {
    let vuethis = this; // 保存this，下面的回调中，this

    // console.log("entrance mounted, productName = " + this.productName);

    // 读本地缓存数据
    this.loadData();
  },
  methods: {
    //开始裁剪
    startcrop(imgurl) {
      this.setCropShape(this.productName);
      this.$refs.cutImg.onStartCrop(imgurl);
    },
    //裁剪完成
    onCropOk(result) {
      this.$refs.imagetransferHome.onCropOk(result);
    },
    onCropCancel() {
      this.$refs.imagetransferHome.onCropCancel();
    },
    pushHistory() {
      if (this.historyState == null) {
        var state = {
          title: "title",
          url: "#"
        };
        window.history.pushState(state, "title", "#");
        this.historyState = 1;
      } else {
        window.history.pushState(this.historyState, "title", "#");
        window.history.forward(1);
      }
    },
    // 保存数据到window.localStorage
    saveData() {
      if (window.localStorage) {
        // localStorage.originalImage = this.buildcontrol.originalImage;
        // localStorage.effectImg = this.buildcontrol.effectImg;
        // localStorage.pixelData = JSON.stringify(this.buildcontrol.pixelData);
      }
    },
    //读取本地缓存
    loadData() {
      if (window.localStorage) {
        let originalImage = localStorage.originalImage;
        let effectImg = localStorage.effectImg;
        let pixelData = localStorage.pixelData;
        if (originalImage && effectImg && pixelData) {
          // this.buildcontrol.setImage(originalImage, effectImg, JSON.parse(pixelData));
          this.$refs.imagetransferHome.showLocalImage(originalImage, effectImg, JSON.parse(pixelData));
        }
      }
    },
    handleTouchStart(event) {
      // 处理 touchstart 事件
      // 点击事件开始需要响应，按默认处理
    },
    handleTouchMove(event) {
      // 处理 touchmove 事件
      // 阻止事件传递到 Swiper
      // event.stopPropagation();

      event.preventDefault();
    },
    handleTouchEnd(event) {
      // 处理 touchend 事件
      // 阻止事件传递到 Swiper
      // 点击事件结束需要响应，按默认处理
    },
    setCropShape(product_path) {
      if (product_path == "DiamondPainting" || product_path == "Romantic") {
        this.crop_showShape = true;
      } else {
        this.crop_showShape = false;
      }
    }
  }
};